if (!customElements.get('product-badge')) {
  customElements.define(
    'product-badge',
    class ProductBadge extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;

        this.unsubscribe = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (!event?.data?.variant) return;
            this.onVariantChange(event.data.variant);
          }
        );
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      onVariantChange(variant) {
        const saleBadge = this.querySelector('[data-badge="sale"]');
        const soldOutBadge = this.querySelector('[data-badge="sold-out"]');
        const freteGratisBadge = this.querySelector('[data-badge="frete-gratis"]');
        const customBadge = this.querySelector('[data-badge="custom"]');


        // Reset
        if (saleBadge) saleBadge.style.display = 'none';
        if (soldOutBadge) soldOutBadge.style.display = 'none';
        if (freteGratisBadge) freteGratisBadge.style.display = 'none';
        if (customBadge) customBadge.style.display = 'none';


        // Sold out
        if (!variant.available && soldOutBadge) {
          soldOutBadge.style.display = '';
          return;
        }

        // Frete Grátis (verificar metafield)
        const freteGratis = variant?.metafields?.custom?.frete_gratis;
        if (freteGratis === true && freteGratisBadge) {
          freteGratisBadge.style.display = '';
        }

        // Custom Badge (metafield da variante)
        const customBadgeText = variant?.metafields?.custom?.custom_badge;

        if (customBadgeText && customBadge) {
          customBadge.textContent = customBadgeText;
          customBadge.style.display = '';
        }

        // Sale
        if (
          variant.available &&
          variant.compare_at_price > variant.price &&
          saleBadge
        ) {
          const discount = Math.round(
            ((variant.compare_at_price - variant.price) * 100) /
              variant.compare_at_price
          );

          saleBadge.textContent = `-${discount}%`;
          saleBadge.style.display = '';
        }
      }
    }
  );
}